import React from "react";
import { Button } from "antd";
import GeneralBloc from "../../../bloc/general_bloc";

class AppTransparentButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() { }

  propButtonWidth() {
    return this.props.buttonWidth;
  }

  propButtonWidth() { return this.props.buttonWidth };

  render() {
    return (
      <Button
        disabled={this.props.type == "reject" ? !this.props.enable : false}
        onClick={(e) => this.props.onClick(e)}
        style={{
          backgroundColor: "transparent",
          color: this.props.type == "reject" && !this.props.enable ? 'rgba(218, 41, 28, 0.5)' : "#FF6624",
          borderRadius: "12px",
          height: "44px",
          fontSize: "16px",
          paddingLeft: "30px",
          paddingRight: "30px",
          width: this.propButtonWidth() || "",
          border: !this.props.borderedLess
            ? this.props.enable
              ? `1px solid #FF6624`
              : `1px solid #CCCC`
            : `0px solid #808EA8`,
        }}
      >
        {" "}
        {this.props.iconBack && (
          <span className="mr-2">
            <img
              src={
                GeneralBloc.getAssetsContextPath() +
                `/assets/icons/ArrowLeftRed.svg`
              }
              alt="New"
              className="mr-2"
            />
          </span>
        )}
        <b dangerouslySetInnerHTML={{
          __html: this.props.label,
        }}></b>
        {this.props.icon && (
          <span className="ml-2">
            <img
              src={
                GeneralBloc.getAssetsContextPath() +
                `/assets/icons/LeftArrowWhite.svg`
              }
              alt="New"
              className="ml-2"
            />
          </span>
        )}
      </Button>
    );
  }
}

export default AppTransparentButton;
